import type { Cart } from 'core/domains';

export function getProductCartItem(code: string, data: Cart['data']) {
  if (!data.items) {
    return {
      quantity: 0,
    };
  }

  const { quantity, ...product } =
    data.items.find((item: { productCode: string }) => item?.productCode === code) || {};

  return {
    ...product,
    quantity: quantity || 0,
  };
}
